import React, { useState } from 'react';
import { Layout, Row, Card, Input } from 'antd';
import { useParams } from 'react-router-dom';
import axiosConfig from '../../../../utils/axiosConfig';
import { Channels } from '../../../common/channelsEnum';
import Title from 'antd/lib/typography/Title';
import { v4 as uuidv4 } from 'uuid';
import { Components } from '../../../common/componentsEnum';
import { ResponseModel } from '../../../../models/fetchingData';
import { EmailComponentProps } from '../../../../models/emailComponents';
import ResourceCreateCommandRow from '../../../common/resourceCreateCommandRow';
import { EditorState } from '../../../common/editorEnum';

const { Content } = Layout;

const NewEmailComponents = (): JSX.Element => {
  const { accountId } = useParams<{ accountId: string }>();
  const [componentId, changeComponentId] = useState<string>();
  const [redirectSubmit, changeRedirectSubmit] = useState(false);
  const [submittingForm, changeSubmittingForm] = useState(false);
  const [nameState, changeNameState] = useState<string>();

  const handleSubmit = async (): Promise<void> => {
    if (nameState) {
      changeSubmittingForm(true);
      const params = {
        componentId: uuidv4(),
        name: nameState
      };

      axiosConfig(
        'post',
        `/${accountId}/components/${Channels.EMAIL}`,
        params,
        (response) => {
          changeSubmittingForm(false);
          changeComponentId(
            (response as ResponseModel<EmailComponentProps>).data.componentId
          );
          changeRedirectSubmit(true);
        },
        (e) => {
          console.log(e);
        }
      );
    }
  };

  return (
    <>
      <Content style={{ padding: '24px' }}>
        <Card>
          <Row>
            <Title level={5}>Name:</Title>
          </Row>
          <Row>
            <Input
              key={'1'}
              data-cy={'Name'}
              style={{
                width: 400
              }}
              defaultValue={nameState}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                changeNameState(e.target.value);
              }}
            />
          </Row>
          <ResourceCreateCommandRow
            postRedirectURL={`/${accountId}/beeEditor/${componentId}/componentName/${nameState}`}
            cancelRedirectURL={`/${accountId}/settings/${Components.EMAIL}`}
            handleSubmit={handleSubmit}
            redirectSubmit={redirectSubmit}
            submittingForm={submittingForm}
            editorState={EditorState.NEW}
          />
        </Card>
      </Content>
    </>
  );
};
export default NewEmailComponents;
